const BASE_DOWNLOAD_TICKET_EVENT = {
    category: 'user_accounts',
    action: 'ticket_download',
    label: undefined,
    property: {},
    value: undefined,
};

function createDownloadTicketEvent({ processingId, ticketType }) {
    return {
        ...BASE_DOWNLOAD_TICKET_EVENT,
        label: ticketType,
        property: {
            processingId: processingId || null,
        },
    };
}

export default {
    createDownloadTicketEvent,
};
